import type { CSSProperties } from "@mui/material";
import type { Dayjs } from "dayjs";
import { uniq } from "lodash-es";

import type { FlightType } from "@/app/lib/context/FlightSelectionPayloadContext/FlightSelectionPayloadContext";
import { determineCabinClasses } from "@/app/lib/utils/cabinClasses";
import type {
  FindFlightOffersFlightSegmentV2,
  FindFlightOffersOfferItemV2,
  GetFlightAvailabilityTokenCabinClass,
} from "@/types/codegen";
import { Feature, isFeatureEnabled } from "@/utils/featureFlags";

export const mapCabinClasses = (
  segment: FindFlightOffersFlightSegmentV2,
  offerItems?: FindFlightOffersOfferItemV2[],
) => {
  const cabinClassesInfo = offerItems
    ?.map((offerItem) => ({
      quantity: offerItem.count,
      ptc: offerItem.ptc,
      type: offerItem.fareComponents.find(
        (fareComponent) => fareComponent.segmentIndex === segment.index,
      )?.cabinTypeCode,
    }))
    .filter(
      (
        cabinClassInfo,
      ): cabinClassInfo is GetFlightAvailabilityTokenCabinClass =>
        cabinClassInfo.type !== undefined,
    );

  const cabinClasses =
    isFeatureEnabled(Feature.CabinClassInOffer) && cabinClassesInfo
      ? determineCabinClasses(cabinClassesInfo)
      : [];

  return cabinClasses;
};

export const isStopOvernight = (
  beginningOfStop: Dayjs,
  stopLength: { hours: number; minutes: number },
) => {
  const endOfStop = beginningOfStop
    .add(stopLength.hours, "hour")
    .add(stopLength.minutes, "minute");
  return (
    endOfStop.startOf("day").diff(beginningOfStop.startOf("day"), "day") > 0
  );
};

export const getNumberOfCarriersHandlingFlight = (flight: FlightType) => {
  const a = flight.segments.flatMap((segment) => [
    segment.marketingCarrier.airline.code,
    segment.operatingCarrier.airline.code,
  ]);

  return uniq(a).length;
};

export const dividerStyle: CSSProperties = {
  position: "relative",
  borderRightWidth: "1px",
  borderLeftWidth: "1px",
  borderColor: "var(--color-stroke-neutral-soft)",
};

export const dotStyle: CSSProperties = {
  content: '""',
  border: "2px solid var(--color-white)",
  position: "absolute",
  left: 0,
  width: "10px",
  height: "10px",
  borderRadius: "50%",
  backgroundColor: "var(--color-text-primary)",
};
